var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-app',{attrs:{"theme":"glittr_nodesign"}},[_c('p-container',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }